import { render, staticRenderFns } from "./GerenciarFontes.vue?vue&type=template&id=0839d20c&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./GerenciarFontes.vue?vue&type=style&index=0&id=0839d20c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0839d20c",
  null
  
)

export default component.exports